import { Observable, from } from "rxjs";

import { services, validateFunctionResult } from "@progressive-development/pd-spa-helper";
import { appUser } from "@progressive-development/politik-model";

import { handleGetFunc, handlePutFunc } from "../../../../config/service-configuration.js";

/**
 * Profile Service
 *
 * Pattern: Service kapselt API-Vertrag (object, type). Methoden nehmen nur
 * Business-Daten, der Service baut das Call-Object intern. Backend ermittelt
 * den User aus `auth.uid` — kein `detailsId` bei "self"-Operationen.
 */
export class ProfileService {
  public loadProfile(): Observable<appUser.UserProfile> {
    const call: appUser.UserProfileDetailCall = {
      object: appUser.USER_PROFILE_OBJECT,
      type: "detail",
    };
    return from(
      services.functions
        .callFunction(handleGetFunc.name, call)
        .then((result) => validateFunctionResult<appUser.UserProfile>(result, handleGetFunc)),
    );
  }

  public updateProfile(details: appUser.UpdateUserProfile): Observable<appUser.UserProfile> {
    const call: appUser.UserProfileUpdateCall = {
      object: appUser.USER_PROFILE_OBJECT,
      type: "update",
      details,
    };
    return from(
      services.functions
        .callFunction(handlePutFunc.name, call)
        .then((result) => validateFunctionResult<appUser.UserProfile>(result, handlePutFunc)),
    );
  }
}

export const profileService = new ProfileService();
